import { Injectable } from '@angular/core';
import { PeerService } from './peer.service';

@Injectable({
  providedIn: 'root'
})
export class NewPeerService extends PeerService {

  private localStream : MediaStream | null = null;
  private sendOffer = false;
  /** Буфер за ICE кандидати, получени преди setRemoteDescription */
  private iceCandidateBuffer: { [peerHash: string]: RTCIceCandidateInit[] } = {};

  constructor() {
    super();
  }

  async preparePeer(createPeer: any, initiator = false, scheduledCall = false) {
    if (!createPeer) {
      this.userHash = "b1a4c49eea93d1f7bb6379983106971c";
    }

    this.initiator = initiator;
    this.Comm.cbOnMessage = this.onMessage.bind(this);
    //this.getUserMedia(true);
    if (initiator && !scheduledCall) {
      this.socketIOService.sendCallOffer(this.chatRoomId, (response: any) => {
        if (response && response.success) {
          this.onPeer(response?.data);
        } else {
          this.onError(response?.data);
        }
      });
    }

    if (!initiator && !scheduledCall) {
      this.socketIOService.answerCallOffer(this.chatRoomId, async (response: any) => {
        if (response && response.success) {
          this.onPeer(response.data);
        } else {
          this.onError(response?.data);
        }
      });
    }

    if (!initiator && scheduledCall) {
      this.socketIOService.joinOngoingCall(this.chatRoomId, (response: any) => {
        if (response && response.success) {
          this.onPeer(response.data);
        } else {
          this.onError(response?.data);
        }
      });
    }

    this.socketIOService.removeEventListeners('room-participants');
    this.socketIOService.roomParticipants((roomId: any, participants: any[]) => {
      if (this.chatRoomId != roomId || !this.userHash) {
        return;
      }
      console.log('participants', participants, this.userHash, roomId);

      // Премахни peers, които вече не са в списъка с участници
      if (this.pc) {
        const participantHashes = new Set(participants.map(p => p.peerHash));
        for (const peerHash in this.pc) {
          if (!participantHashes.has(peerHash)) {
            this.removePeer(peerHash);
          }
        }
      }

      for (let participant of participants) {
        if (this.pc && this.pc[participant.peerHash]) {
          continue;
        }
        if (this.sendOffer == false) {
          if (participant.peerHash != this.userHash) {
            this.createPeer(participant.peerHash, true);
          } else  {
            //this.createPeer(participant.peerHash);
            this.sendOffer = true;
          }
        } else {
          this.createPeer(participant.peerHash);
        }
      }

      if (this.onParticipantsUpdated) {
        this.onParticipantsUpdated(roomId, participants);
      }
    });
  }


  async getUserMedia(front: boolean): Promise<MediaStream> {
    let video: any;

    if (front) {
      video = true;
    } else {
      video = { facingMode: { exact: "environment" } };
    }

    try {
      let stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: true
      });
      //stream = this.createWhiteTimingStream();
      this.localStream = stream;
      this.attach(this.localStream, this.userHash);
      console.log('GETUSERMEDIA');
      
      // for (let userHash in this.pc) {
      //   if (userHash == this.userHash) continue;
      //   this.addLocalTrack(userHash);
      //   this.createOffer(userHash);
      // }
      return stream;
    } catch (error) {
      console.log(error);

      if (error.name === "OverconstrainedError" && !front) {
        // fallback to front camera
        return this.getUserMedia(true);
      }


      return;
    }
  }

  onPeer(peer: any) {
    console.log('On peer', peer.userHash);
    this.sendOffer = false;
    this.userHash = peer.userHash;
    this.Comm.wsSetUserHash(peer.userHash);
    this.Comm.wsSetRoomID(peer.roomHash);
    this.Comm.newServiceSend('join');
  }

  addLocalTrack(userHash: any) {
    console.log('add track', this.userHash, userHash);
    if (!this.userHash || this.userHash == userHash) {
      return;
    }
    const pc = this.pc[userHash];
    const senders = pc.getSenders();
    this.localStream?.getTracks().forEach(track => {
      pc.addTrack(track, this.localStream!);
    });
  }

  async createOffer(userHash: any) {
    console.log('Creating offer to ', userHash);
    if (!this.userHash || this.userHash == userHash) {
      return;
    }
    const pc = this.pc[userHash];
    pc.createOffer().then(async (desc: any) => {
      await pc.setLocalDescription(desc);
      console.log(pc.localDescription);
      //self.sendSdp(desc.sdp, outgoing, callee, media)
      this.Comm.newServiceSend('offer', desc, null, userHash);
    }, function (error: any) {
      console.error(error);
    });
  }

  async onMessage(message: any) {
    if (!message) {
      return;
    }
    const { type, payload } = JSON.parse(message.data);
    if (this.userHash != payload?.to) {
      return;
    }
    const pc = this.pc[payload.from];
    console.log('Received message', type, this.userHash, payload);
    switch (type) {
    case 'offer':
      if (pc.signalingState !== 'stable') return;
      await pc.setRemoteDescription(payload);
      await this.drainIceCandidates(payload.from);
      const answer = await pc.createAnswer();
      await pc.setLocalDescription(answer);
      this.Comm.newServiceSend('answer', answer, null, payload.from);
      break;
    case 'answer':
      if (pc.signalingState !== 'have-local-offer') return;
      await this.pc[payload.from].setRemoteDescription(payload);
      await this.drainIceCandidates(payload.from);
      break;

    case 'ice':
      this.addOrBufferIceCandidate(payload.from, payload);
      break;
    case 'connected':
      break;
    case 'disconnect':
      //add logic for disconnect
      break;
    case 'recorderFile':
      console.log('Record is in ', payload.fileName);
      break;
    }
  }

  /**
   * Добавя ICE кандидат директно ако remoteDescription е зададен,
   * иначе го буферира за по-късно.
   */
  private addOrBufferIceCandidate(peerHash: string, candidateInit: RTCIceCandidateInit & { from?: string; to?: string }) {
    const pc = this.pc[peerHash];
    if (!pc) return;

    const { from: _from, to: _to, ...iceInit } = candidateInit;
    const init: RTCIceCandidateInit = iceInit;

    if (pc.remoteDescription) {
      try {
        pc.addIceCandidate(init);
      } catch (e) {
        console.warn('Error adding ICE candidate', e);
      }
    } else {
      if (!this.iceCandidateBuffer[peerHash]) {
        this.iceCandidateBuffer[peerHash] = [];
      }
      this.iceCandidateBuffer[peerHash].push(init);
    }
  }

  /**
   * Прилага всички буферирани ICE кандидати след setRemoteDescription.
   */
  private async drainIceCandidates(peerHash: string): Promise<void> {
    const pc = this.pc[peerHash];
    const buffer = this.iceCandidateBuffer[peerHash];
    if (!pc || !buffer?.length) return;

    for (const init of buffer) {
      try {
        await pc.addIceCandidate(init);
      } catch (e) {
        console.warn('Error adding buffered ICE candidate', e);
      }
    }
    this.iceCandidateBuffer[peerHash] = [];
  }

  removePeer(peerHash: string) {
    const pc = this.pc[peerHash];
    console.log('Removing peer', peerHash, this.pc);
    if (pc) {
      try {
        // pc.getSenders().forEach((sender: any) => {
        //   if (sender.track) sender.track.stop();
        // });
        // pc.getReceivers().forEach((receiver: any) => {
        //   if (receiver.track) receiver.track.stop();
        // });
        pc.close();
      } catch (error) {
        console.error('Error closing peer connection:', error);
      }
      delete this.pc[peerHash];
    }
    delete this.iceCandidateBuffer[peerHash];
    this.removeMediaFn(peerHash);
  }

  createPeer(who: any, createOffer = false) {
    if (this.userHash == who) {
      return;
    }
    console.log('CREATING PEER ', this.userHash, who);
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    const configuration: RTCConfiguration = {
      iceServers: [
        {
          urls: [
            // Use the schemes supported and enabled by your TURN deployment.
            // For highest reliability, include multiple transports (udp, tcp, tls).
            "turn:94.26.9.237:49206?transport=udp",
            "turn:94.26.9.237:49206?transport=tcp",
            "turns:94.26.9.237:49214?transport=tcp"
          ],
          username: 'turnuser',
          credential: 'turnpass'
        }
      ],
      // Optional: ICE transport policy
      // 'all' (default) allows host/srflx/relay; 'relay' forces relay-only (TURN).
      // If you truly want TURN-only, set iceTransportPolicy to 'relay'.
      // Note: Some older browsers may ignore this setting; test across targets.
      iceTransportPolicy: 'relay'
    };
    if (!this.pc) {
      this.pc = [];
    }
    if (this.pc[who]) {
      return;
    }

    const pc = new RTCPeerConnection(configuration);
    this.pc[who] = pc;
    this.addLocalTrack(who);
    pc.addTransceiver('audio', { direction: 'sendrecv' });
    pc.addTransceiver('video', { direction: 'sendrecv' });
    pc.ontrack = (e: any) => {
      const stream = e.streams[0];
      console.log('remote stream', this.userHash, who);
      this.attach(stream, who);
    };
    pc.onicecandidate = (e: any) => {
      if (e.candidate) {
        const payload = {
          candidate: e.candidate,
        };
        setTimeout(() => {
          this.Comm.newServiceSend('ice', e.candidate.toJSON(), null, who);
        }, 100);
        
      } else {
        console.log('aaaa', 'no ice candidate');
      }
    };
    const fn = this.removeMediaFn.bind(this);

    pc.oniceconnectionstatechange = function (e) {
      if (pc.iceConnectionState == 'closed' || pc.iceConnectionState == 'disconnected') {
        fn(who);

        //self.pcIsDown(callee, media);

      }

      if (pc.iceConnectionState == 'connected') {
        that.connecting.next(false);
      }
    };
    pc.onicegatheringstatechange = () =>
      console.log('Gathering', pc.iceGatheringState);
    // TURN keep-alive via data channel
    const keepaliveChannel = pc.createDataChannel("keepalive");
    keepaliveChannel.onopen = () => {
      console.log("keepalive channel open — starting pings");
      // Send a tiny ping every 15 s
      setInterval(() => {
        if (keepaliveChannel.readyState === "open") {
          keepaliveChannel.send("ping");
        }
      }, 15000);
    };

    pc.ondatachannel = (event) => {
      if (event.channel.label === "keepalive") {
        const ch = event.channel;
        ch.onmessage = (ev) => console.log("keepalive:", ev.data);
      }
    };
    if (createOffer) {
      this.createOffer(who);
    }
  }

  createWhiteTimingStream(): MediaStream {
    const canvas = document.createElement("canvas");
    canvas.width = 640;
    canvas.height = 480;

    const ctx = canvas.getContext("2d")!;
    
    setInterval(() => {
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = "#000";
      ctx.font = "48px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(
        new Date().toLocaleTimeString(),
        canvas.width / 2,
        canvas.height / 2
      );
    }, 1000);
    return (canvas as any).captureStream(5);
  }

  closeStream() {
    // Stop local stream tracks
    if (this.localStream) {
      this.localStream.getTracks().forEach(track => {
        track.stop();
      });
      this.localStream = null!;
    }

    // Close all peer connections
    if (this.pc) {
      for (let userHash in this.pc) {
        const pc = this.pc[userHash];
        if (pc) {
          try {
            // Stop all sender tracks
            pc.getSenders().forEach((sender: any) => {
              if (sender.track) {
                sender.track.stop();
              }
            });
            // Stop all receiver tracks
            pc.getReceivers().forEach((receiver: any) => {
              if (receiver.track) {
                receiver.track.stop();
              }
            });
            // Close the peer connection
            pc.close();
          } catch (error) {
            console.error('Error closing peer connection:', error);
          }
        }
      }
      // Clear all peer connections
      this.pc = {};
    }
    this.iceCandidateBuffer = {};

    this.userHash = null!;
    this.sendOffer = false;
  }

}
